import React from "react";
import clsx from "clsx";

import { useTranslation } from "lib/i18n/use-translation";
import styles from "./stat-cards.module.scss";
import { BaseScore } from "apps/user/learner/api/types";

interface IndexSummaryCardProps {
  overallIndexScore?: BaseScore;
  flush?: boolean;
}

const IndexSummaryCard: React.FC<IndexSummaryCardProps> = ({
  overallIndexScore,
  flush = false,
}) => {
  const scoreValue = overallIndexScore?.value;
  const scoreLabel = overallIndexScore?.label;
  const { t } = useTranslation(["index"]);

  return (
    <div
      className={clsx(
        styles["index-summary-card"],
        flush && styles["index-summary-card--flush"]
      )}
      data-testid="index-summary-card"
    >
      <span className={styles["index-summary-title"]}>
        {t("index:screen.title")}
      </span>
      <div className={styles["index-summary-row"]}>
        <span className={styles["index-summary-value"]}>{scoreValue}</span>
        {scoreLabel && (
          <span className={styles["index-summary-status"]}>{scoreLabel}</span>
        )}
      </div>
    </div>
  );
};

export default IndexSummaryCard;
